var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{ active: _vm.isActive },on:{"click":_vm.goToPage}},[_c('IconFont',{attrs:{"name":_vm.itemData.icon,"size":"18"}}),_c('span',[_vm._v(_vm._s(_vm.itemData.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }